import React from "react";
import { Button, Glyphicon, Row, Col } from "react-bootstrap";
import _ from "lodash";

import TagActions from "../actions/TagActions";

import TagStore from "../stores/TagStore";

import TagDeleteModal from "./TagDeleteModal";
import TagEditModal from "./TagEditModal";

export default class Tags extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = Tags.getStoreState();
		this.state.showTagDeleteModal = false;
		this.state.showTagEditModal = false;

		this._onChange = this._onChange.bind(this);
		this.handleTagDeleteModalClose = this.handleTagDeleteModalClose.bind(this);
		this.handleTagEditModalClose = this.handleTagEditModalClose.bind(this);
	}

	static getStoreState()
	{
		return {
			tags: TagStore.getTags()
		};
	}

	handleTagDeleteModalClose()
	{
		this.setState({
			deleteTagId: null,
			showTagDeleteModal: false
		});
	}

	handleTagEditModalClose()
	{
		this.setState({
			editTagId: null,
			showTagEditModal: false
		});
	}

	handleTagDelete(tagId)
	{
		this.setState({
			deleteTagId: tagId,
			showTagDeleteModal: true
		});
	}

	handleTagEdit(tagId)
	{
		this.setState({
			editTagId: tagId,
			showTagEditModal: true
		});
	}

	_onChange()
	{
		this.setState(Tags.getStoreState());
	}

	componentDidMount()
	{
		TagStore.addChangeListener(this._onChange);
		TagActions.initialize();
	}

	componentWillUnmount()
	{
		TagStore.removeChangeListener(this._onChange);
	}

	render()
	{
		const tags = this.state.tags;

		return (
			<Row>
				{this.state.showTagEditModal &&
					<TagEditModal
						onClose={this.handleTagEditModalClose}
						onSave={TagActions.saveTag}
						tag={_.cloneDeep(tags.find(c => c.id === this.state.editTagId))}
					/>
				}
				{this.state.showTagDeleteModal &&
					<TagDeleteModal
						onClose={this.handleTagDeleteModalClose}
						onDelete={TagActions.deleteTag}
						tagId={this.state.deleteTagId}
					/>
				}
				<Col xs={10} xsOffset={1}>
					<Row>
						<Col xs={5}>
							<strong>Tag</strong>
						</Col>
						<Col xs={7} />
					</Row>
					{tags.map(tag => {
						return (
							<Row key={tag.id} className="tag">
								<Col xs={5}>
									{tag.text}
								</Col>
								<Col xs={7} className="tag-buttons">
									<Button
										bsSize={"sm"}
										bsStyle={"default"}
										onClick={this.handleTagEdit.bind(this, tag.id)}
									>
										<Glyphicon glyph="pencil"/>
									</Button>
									<Button
										bsSize={"sm"}
										bsStyle={"danger"}
										onClick={this.handleTagDelete.bind(this, tag.id)}
									>
										<Glyphicon glyph={"trash"}/>
									</Button>
								</Col>
							</Row>
						);
					})}
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./Components/components/Tags.jsx